import React  from 'react'
import Spinner from '../../Spinner/spinner';
import { ToastContainer} from "react-toastify";
import NumberInput from '../../../Component/PhoneInput/phoneInput';
import UseAddLead from './Hooks/useAddLead';

const AddLead = () => {
    const {
        spinner,
        leadAdd,
        countryData,
    } = UseAddLead()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Add Lead
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={leadAdd.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Name *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={leadAdd.handleChange}
                                value={leadAdd.values.name}
                            />
                            {leadAdd.touched.name && leadAdd.errors.name ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadAdd.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Business Name*</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='providerName'
                                onChange={leadAdd.handleChange}
                                value={leadAdd.values.providerName}

                            />
                            {leadAdd.touched.providerName && leadAdd.errors.providerName ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadAdd.errors.providerName}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Email *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='email'

                                onChange={leadAdd.handleChange}
                                value={leadAdd.values.email}
                            />
                            {leadAdd.touched.email && leadAdd.errors.email ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadAdd.errors.email}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Mobile Number *</label>
                            {/* <input type="number" className="form-control"
                                id="recipient-name"
                                name='mobileNo'
                                onChange={leadAdd.handleChange}
                                value={leadAdd.values.mobileNo}
                                maxLength={10}
                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}

                            /> */}
                            <NumberInput
                                width={false}
                                Require={false}
                                Name="mobileNo"
                                HandleChange={leadAdd}
                                Value={leadAdd.values.mobileNo}
                            />
                            {leadAdd.touched.mobileNo && leadAdd.errors.mobileNo ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadAdd.errors.mobileNo}
                                </div>
                            ) : null}
                        </div>

                        <div className='col-md-6'>
                            <label htmlFor="recipient-name" className="col-form-label">Country *</label>
                            <select className='form-select' name='country' onChange={leadAdd.handleChange} value={leadAdd.values.country}>
                                <option hidden>Select Country</option>
                                {
                                    countryData?.map((item, index) =>
                                        <option value={item._id}>{item.name}</option>

                                    )}
                            </select>
                            {leadAdd.touched.country && leadAdd.errors.country ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadAdd.errors.country}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Description *</label>
                            <textarea className='form-control' cols="30" rows="1" name='description' onChange={leadAdd.handleChange} value={leadAdd.values.description}></textarea>
                            {leadAdd.touched.description && leadAdd.errors.description ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadAdd.errors.description}
                                </div>
                            ) : null}
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default AddLead